import styled from "styled-components";
import { SelectBox } from "../inputs/select-box";

// tslint:disable-next-line
export const ManagerSelectBox = styled(SelectBox)`
  vertical-align: top;
`;
